export const BUNDLE_STATUS_DRAFT = 'draft'
export const BUNDLE_STATUS_PENDING = 'pending-review'
export const BUNDLE_STATUS_IN_REVIEW = 'in-review'
export const BUNDLE_STATUS_REJECTED = 'twilio-rejected'
export const BUNDLE_STATUS_APPROVED = 'twilio-approved'
